import React from 'react'
import Heading from 'constructicon/heading'
import InjectURLParams from '../../utils/InjectURLParams'

const Title = ({
  children,
  ...props
}) => (
  <Heading {...props}>
    <InjectURLParams>{children}</InjectURLParams>
  </Heading>
)

export default Title



// WEBPACK FOOTER //
// ./components/ui/Title/index.js